import { singleton } from "tsyringe";
import type { CurriculumDto } from "@/entities/curriculum/domain/dtos";

export interface BigUnitBehaviorStructure {
    checkRegularCurriculum: (curriculum: CurriculumDto) => boolean;
}

@singleton()
export class BigUnitBehaviors implements BigUnitBehaviorStructure {
    public checkRegularCurriculum = (curriculum: CurriculumDto) => {
        const { bigUnit } = curriculum;

        return bigUnit.id < 400;
    };
}
